import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import prompt from './modules/prompt'
import course from './modules/course'
import goods from './modules/goods'
import assets from './modules/assets'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: { user, prompt, course, goods, assets },
})
